import { useTranslation } from 'react-i18next';
import { create } from 'zustand';
import { Button } from './Button';
import { Dialog } from './Dialog';

interface ConfirmRequest {
  title: string;
  message: string;
  confirmLabel: string;
  danger?: boolean;
  resolve(ok: boolean): void;
}

const useConfirmStore = create<{ request: ConfirmRequest | null }>(() => ({ request: null }));

/** `if (await confirm({...})) remove()` - one host renders every confirmation dialog. */
export function confirm(options: Omit<ConfirmRequest, 'resolve'>): Promise<boolean> {
  return new Promise((resolve) => useConfirmStore.setState({ request: { ...options, resolve } }));
}

export function ConfirmHost() {
  const request = useConfirmStore((s) => s.request);
  const { t } = useTranslation();
  const close = (ok: boolean) => {
    request?.resolve(ok);
    useConfirmStore.setState({ request: null });
  };
  return (
    <Dialog
      open={request !== null}
      onClose={() => close(false)}
      title={request?.title ?? ''}
      variant="alert"
      footer={
        <>
          <Button onClick={() => close(false)}>{t('common.cancel')}</Button>
          <Button
            variant={request?.danger ? 'danger' : 'primary'}
            onClick={() => close(true)}
            autoFocus
          >
            {request?.confirmLabel}
          </Button>
        </>
      }
    >
      <p>{request?.message}</p>
    </Dialog>
  );
}
